/**
 * Utility class for handling attribution tracking operations across user journeys
 */
export class AttributionUtils {
    /**
     * Enriches data object with business correlation ID for journey attribution tracking
     * @param businessCorrelationID - Optional business correlation ID to append
     * @param data - Target data object to enrich
     */
    public static enrichWithBusinessCorrelationId(
        businessCorrelationID: string | undefined,
        data: any,
    ): void {
        if (!businessCorrelationID) {
            return;
        }
        data.BusinessCorrelationID = businessCorrelationID;
    }
}
